import React, { useEffect, useState } from 'react';
import { usersDesignationServices } from '../../../APIServices/usersDesignationServices';
import { useToast } from '../../../hooks/useToast';

function UpdateDesignation({
  designationData,
  setConfirm,
  confirm,
  setModalOpen,
  getUserDesignationData
}) {
  const toast = useToast();
  const [buttonLoader, setButtonLoader] = useState(false);
  const [designation, setDesignation] = useState("");

  const updateUserDesignationData = async (e) => {
    setButtonLoader(true);
    try {
      let userData = {};
      userData.designationId = designationData?.designationId;
      userData.designation = designation;
      let data = await usersDesignationServices.updateUserDesignationData(
        userData
      );
      if (data?.statusCode === 200) {
        toast(data?.customMessage || 'Designation updated successfully.', 'ok');
        getUserDesignationData();
        setConfirm(false);
        setModalOpen("");
        setDesignation("");
      } else {
        toast(data?.customMessage || 'Unable to update designation.', 'warn');
      }
    } catch (error) {
      toast('Unable to update designation. Please try again.', 'warn');
    } finally {
      setButtonLoader(false);
    }
  }

  useEffect(() => {
    setDesignation(designationData?.designation);
  }, [designationData]);

  return (
    <div
      className="modal-backdrop"
      onClick={() =>
        setModalOpen("")
      }
    >
      <div
        className="modal"
        style={{ maxWidth: 480 }}
        onClick={(e) =>
          e.stopPropagation()
        }
      >
        <div className="modal-head">
          <div>
            <div className="modal-title">
              Edit Designation
            </div>

            <div className="xs muted">
              Update the designation details
            </div>
          </div>

          <button
            className="icon-btn"
            onClick={() =>
              setModalOpen("")
            }
          >
            <i className="ti ti-x" />
          </button>
        </div>

        <div className="modal-body">
          <div className="field">
            <label className="field-label">
              Designation Name
              <span className="req">
                *
              </span>
            </label>
            <input
              className="inp"
              autoFocus
              disabled={buttonLoader || confirm}
              placeholder="e.g., Clinical Lead"
              value={designation}
              onChange={(e) => setDesignation(e.target.value)}
            />
          </div>
        </div>

        <div className="modal-foot">
          {confirm ?
            <>
              <button
                className="btn btn-ghost"
                onClick={() => setConfirm(false)}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary d-flex align-items-center justify-content-center gap-2"
                onClick={updateUserDesignationData}
                disabled={buttonLoader || !designation}
              >
                {buttonLoader ? (
                  <>
                    <div className="buttonLoader"></div>
                    <span>Updating...</span>
                  </>
                ) : (
                  <>
                    <i className="ti ti-check"></i>
                    <span>Yes, Update It!</span>
                  </>
                )}
              </button>
            </>
            :
            <>
              <button
                className="btn btn-ghost"
                onClick={() => setModalOpen("")}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary d-flex align-items-center justify-content-center gap-2"
                onClick={() => setConfirm(true)}
              >
                Update Designation
              </button>
            </>
          }
        </div>
      </div>
    </div>
  );
}

export default UpdateDesignation;
